import { request } from '@/utils/request';
import {
  MedicalUnit,
  MedicalUnitAggregatedScheduleRes,
  MedicalUnitScheduleRes,
} from '@/api/medicalUnits/medicalUnits.types';

export async function getDataAboutClinic() {
  return request<MedicalUnit>('/units/1');
}

export async function getTodaySchedule({ id }: { id: number }) {
  return request<MedicalUnitScheduleRes>(`/schedule/get-today-schedule-by-medical-unit/${id}/`, {
    next: {
      revalidate: 60,
    },
  });
}

export async function getAggregatedSchedule({ id }: { id: number }) {
  return request<MedicalUnitAggregatedScheduleRes>(`/schedule/get-current-aggregated-schedule-by-medical-unit/${id}/`, {
    next: {
      revalidate: 60,
    },
  });
}